
export default (time, callback) -> setTimeout callback, time
